import { h, Fragment } from "preact";
import { useState, useEffect } from "preact/hooks";
import register from "preact-custom-element";
import SwatchProductActions from "../../pdp-swatch-modal/swatch-product-actions";
import { Swatch } from "../../helpers/icons";

export default function ProductOptionSwatchActions({
  price,
  currency,
  swatchType,
  variantId,
  productGid,
}) {
  const [cartData, setCartData] = useState(window.cartData);
  const [error, setError] = useState(null);

  const cartItems = cartData?.items || [];

  const onError = () => {
    setError(window.localeStrings.product.add_to_cart_error);
    setTimeout(() => {
      setError(null);
    }, 3000);
  };

  const item = cartItems.find(
    (cartItem) => parseInt(cartItem.variant_id) === parseInt(variantId),
  );

  useEffect(() => {
    const onCartUpdated = (e) => {
      setCartData(e.detail.cartData);
    };

    document.addEventListener("cart:updated", onCartUpdated);

    return () => document.removeEventListener("cart:updated", onCartUpdated);
  }, [setCartData]);

  const isRug = swatchType === "rug";
  const addToCartText = isRug
    ? window.localeStrings.product.request_rug_sample_price.replace(
        "[price]",
        window.formatMoney(price, false, currency),
      )
    : window.localeStrings.product.request_swatch;
  const removeFromCartText = isRug
    ? window.localeStrings.product.rug_sample_in_cart
    : window.localeStrings.product.swatch_in_cart;

  const openCart = () => {
    document.dispatchEvent(new CustomEvent("markup-modal:close"));
    document.dispatchEvent(new CustomEvent("mini-cart:open"));
  };

  return (
    <>
      <SwatchProductActions
        variantId={variantId}
        productGid={productGid}
        item={item}
        limitEach={1}
        onError={onError}
        onAfterAdd={openCart}
        classPrefix="product-option-swatch-actions"
        removeButtonClasses="button button--small-round button--full main-product-details__swatch-button disabled"
        addButtonClasses="button button--small-round button--full main-product-details__swatch-button"
        addToCartText={
          <>
            <Swatch />
            {addToCartText}
          </>
        }
        removeFromCartText={removeFromCartText}
        swatchType={swatchType}
        removeAction={openCart}
      />
      {error && (
        <div
          className="product-form-swatch-actions__error"
          dangerouslySetInnerHTML={{
            __html: error,
          }}
        ></div>
      )}
    </>
  );
}

if (!customElements.get("product-option-swatch-actions")) {
  register(
    ProductOptionSwatchActions,
    "product-option-swatch-actions",
    ["price", "currency", "variant-id", "swatch-type"],
    {
      shadow: false,
    },
  );
}
